import React from 'react';

const Message = ({ children, variant = 'info', onClose }) => {
  // Set background and text colors based on variant
  const getVariantClasses = () => {
    switch (variant) {
      case 'success':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'error':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'warning':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'info':
      default:
        return 'bg-blue-100 text-blue-800 border-blue-200';
    }
  };

  return (
    <div className={`p-4 mb-4 rounded border ${getVariantClasses()} relative`} role="alert">
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-1 right-1 text-gray-600 hover:text-gray-800"
          aria-label="Close"
        >
          <span className="text-xl">&times;</span>
        </button>
      )}
      <div className="flex items-center">
        {children}
      </div>
    </div>
  );
};

export default Message;